






















































import { computed, defineComponent, PropType, ref, watch } from '@nuxtjs/composition-api';
// eslint-disable-next-line import/no-named-as-default
import Swiper from 'swiper';

type SliderControlsStyle = 'DEFAULT' | 'MODEL_ART_TWO' | 'PRODUCT_SLIDER' | 'BLACK_FULL_BOTTOM';

export default defineComponent({
  name: 'OfferSliderControls',
  props: {
    content: {
      type: Array,
      default: () => [],
    },
    activeSlide: {
      type: Number,
      default: 0,
    },
    swiperInstance: {
      type: Object as PropType<Swiper>,
      required: true,
    },
    compStyle: {
      type: String as PropType<SliderControlsStyle>,
      default: 'DEFAULT',
      validator: (v: string) => ['DEFAULT', 'MODEL_ART_TWO', 'PRODUCT_SLIDER', 'BLACK_FULL_BOTTOM'].includes(v),
    },
    loop: {
      type: Boolean,
      default: false,
    },
    slideNumbers: {
      type: Boolean,
      default: false,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const currentActiveSlide = ref(props.activeSlide);
    const swiperInstanceRef = ref(props.swiperInstance);
    const isEndSlide = computed(() => !props.loop && swiperInstanceRef.value.isEnd);
    const isStartSlide = computed(() => !props.loop && swiperInstanceRef.value.isBeginning);

    function nextSlide() {
      if (isEndSlide.value) return;

      // If the slider is on loop mode and the current slide is the last one, we need to go back to the first one
      // Since Swiper's loop feature causes the page to freeze
      if (props.loop && props.activeSlide === props.content.length - 1) {
        swiperInstanceRef.value?.slideTo(0);
        return;
      }

      swiperInstanceRef.value?.slideNext();
    }

    function prevSlide() {
      if (isStartSlide.value) return;

      swiperInstanceRef.value?.slidePrev();
    }

    watch(
      () => props.activeSlide,
      newValue => {
        currentActiveSlide.value = newValue;
      }
    );

    watch(currentActiveSlide, newValue => {
      swiperInstanceRef.value?.slideTo(newValue);
    });

    return {
      currentActiveSlide,
      isEndSlide,
      isStartSlide,
      nextSlide,
      prevSlide,
    };
  },
});
